import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';
export function Sensory() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 lg:py-48 bg-cream text-chocolate" data-id="element-220">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-5 lg:order-1 order-2" data-id="element-222">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-223">
            <span className="w-10 h-px bg-caramel/50" data-id="element-224" />
            {t.sensory.eyebrow}
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-chocolate leading-[0.95] tracking-[-0.02em] font-light" data-id="element-225">
            {t.sensory.title1}
            <br data-id="element-226" />
            <span className="italic font-extralight" data-id="element-227">{t.sensory.title2}</span>
          </h2>
          <p className="mt-10 text-chocolate/60 leading-[1.8] text-[15px] max-w-md" data-id="element-228">
            {t.sensory.copy}
          </p>

          <div className="mt-12 grid grid-cols-2 gap-x-8 gap-y-6" data-id="element-229">
            {t.sensory.specs.map(s => <div key={s.l} data-id="element-230">
                <p className="text-[10px] tracking-[0.3em] uppercase text-chocolate/40 mb-3" data-id="element-231">
                  {s.l}
                </p>
                <p className="font-serif text-lg text-chocolate font-light" data-id="element-232">
                  {s.v}
                </p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 1.02
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:col-span-7 lg:order-2 order-1 relative group" data-id="element-233">
          <div className="aspect-[5/4] overflow-hidden bg-warmwhite" data-id="element-234">
            <img src={IMAGES.box} alt="The TARTA signature box" className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.03]" data-id="element-235" />
          </div>
          <div className="mt-4 flex items-center justify-between text-[10px] tracking-[0.3em] uppercase text-chocolate/40" data-id="element-236">
            <span data-id="element-237">{t.sensory.detailNo}</span>
            <span data-id="element-238">{t.sensory.detailLabel}</span>
          </div>
        </motion.div>
      </div>
    </section>;
}